var DateFetchService = function () {
    
    "use strict";

    var self = this;

    this.initialize = function () {
    };
    
    this.checkIfHasSelectedDates = function () {
        if ($('[data-entity=datevalue]').val() != '' && !myApp.bookingConfigurator.showDatesCalendar) {
            myApp.domManager.toggleClass($('[data-value=' + $('[data-entity=datevalue]').val() + ']'), $('tr'), 'active');
            if (myApp.deviceDetector.isMdScreen() || myApp.deviceDetector.isLgScreen()) {
                myApp.scrollManager.scrollContainerToElement('[data-entity=table-scrollable]', $('[data-value=' + $('[data-entity=datevalue]').val() + '] td'));
            } else {
                if (myApp.urlManager.getUrlParam('data')) {
                    self.cloneAndAppendSelectedDate($('[data-entity=datevalue]').val());
                }
            }
            myApp.bookingSummaryService.booking.setStartDate($('[data-value=' + $('[data-entity=datevalue]').val() + ']').data('startdate'));
            myApp.bookingSummaryService.booking.setEndDate($('[data-value=' + $('[data-entity=datevalue]').val() + ']').data('enddate'));
            myApp.bookingSummaryService.updateView();
            myApp.bookingConfigurator.showContinueButton();
        } else {
            const queryParams = new URLSearchParams(window.location.search);
            if (myApp.browserStorageService.getBrowserStorageAvailable() && !queryParams.has('nc')) {
                let start = localStorage.getItem('start');
                let end = localStorage.getItem('end');
                if (start && end) {
                    let startDateArray = start.split("-");
                    let endDateArray = end.split("-");
                    if (!myApp.bookingConfigurator.showDatesCalendar) {
                        let startDateFormatted = startDateArray[2] + '-' + startDateArray[1] + '-' + startDateArray[0];
                        let endDateFormatted = endDateArray[2] + '-' + endDateArray[1] + '-' + endDateArray[0];
                        let dateElement = $('[data-entity=table-scrollable] [data-startdate="' + startDateFormatted + '"][data-enddate="' + endDateFormatted + '"] [data-entity="date"]');

                        if (dateElement.length > 0) {
                            let eventElement = $(dateElement[0]);
                            if (eventElement.data('date-action') == 'default') {
                                myApp.scrollManager.scrollContainerToElement('[data-entity=table-scrollable]', dateElement);
                                eventElement.click();
                            }
                        }
                    } else {
                        let calendarStartDate = startDateArray[1] + '/' + startDateArray[0] + '/' + startDateArray[2];
                        let calendarEndDate = endDateArray[1] + '/' + endDateArray[0] + '/' + endDateArray[2];
                        let calendarDayContainer = $('.flatpickr-days .flatpickr-day[aria-label="' + calendarStartDate + '"]');
                        const startDate = new Date(calendarStartDate).getTime();
                        const endDate = new Date(calendarEndDate).getTime();
                        const numDays = (endDate - startDate) / (1000 * 3600 * 24);
                        if (
                            calendarDayContainer && !calendarDayContainer.hasClass('flatpickr-disabled') &&
                            myApp.bookingConfigurator.availableDatesCalendarManager.numDays === numDays && endDate > startDate
                        ) {
                            calendarDayContainer.click();
                        }
                    }
                }
            }
        }
    };
    
    this.cloneAndAppendSelectedDate = function (val) {
        myApp.bookingConfigurator.showContinueButton();
        $('[data-entity=searched-dates-container]').show();
        $('[data-value=' + val + ']').clone().appendTo('[data-entity=cloned-date]');
    };
};

export default DateFetchService;
